module.exports = __webpack_public_path__ + "img/linkedin.2ed2d6bb.svg";